import { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { formSubmissionRefs } from "../subjects/formSubmission/refs";

/**
 * The driver answered a verification request.
 */
export const verificationResponseV1 = tmsEventKind(
  { category: "acknowledgement", kind: "verificationResponse", version: 1 },
  {
    refs: formSubmissionRefs,
    facts: {
      confirmation: z.string().nullable(),
    },
  },
);

export const VerificationResponseV1Schema = verificationResponseV1.schema;
export const VerificationResponseV1FactsSchema = verificationResponseV1.facts;

export type VerificationResponseV1 = z.infer<typeof VerificationResponseV1Schema>;
export type VerificationResponseV1Facts = z.infer<typeof VerificationResponseV1FactsSchema>;

/** Every version of `verificationResponse`, keyed by version. What `catalog.ts` places under `acknowledgement`. */
export const verificationResponse = { 1: verificationResponseV1 } as const;
